import { ref, computed } from 'vue'
import { type ServiceType, SERVICE_MAP, SERVICE_STORAGE_KEY } from '@/constants/environments'

const currentService = ref<ServiceType>(loadSavedService())

function loadSavedService(): ServiceType {
  try {
    const saved = localStorage.getItem(SERVICE_STORAGE_KEY)
    if (saved && saved in SERVICE_MAP) {
      return saved as ServiceType
    }
  } catch {
    // localStorage unavailable (SSR or privacy mode)
  }
  return 'main'
}

export function useEnvironment() {
  const current = computed(() => SERVICE_MAP[currentService.value])

  function setService(service: ServiceType) {
    currentService.value = service
    try {
      localStorage.setItem(SERVICE_STORAGE_KEY, service)
    } catch {
      // ignore
    }
  }

  return {
    currentService: current,
    currentServiceKey: currentService,
    setService,
  }
}
